import './styles/contact.css'
import { initReveal } from './reveal'
import { initNav } from './nav'
import { initAnalytics } from './analytics'
import { initEnquiryForm } from './enquiry-form'

document.documentElement.dataset['env'] = import.meta.env.VITE_ENV_NAME

initAnalytics()
initNav()
initReveal()
initEnquiryForm()
